import { ListTodo } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { PERMISSIONS, usePermission } from '@/lib/permissions'
import { cn } from '@/lib/utils'

/**
 * My Tasks from anywhere (z8nrz7fh6h): an icon in the header line, beside
 * Audit — the same two places as AuditCenterLink and ShiftDashboardLink (the
 * TopBar, and the /dashboard header, which hides the TopBar).
 *
 * Everyone with my_tasks.read sees their own day or week; a supervisor
 * (resource_calendar.read_all) sees every resource. The server decides which.
 */
export function MyTasksLink() {
  const { canAny } = usePermission()
  if (!canAny([PERMISSIONS.myTasksRead, PERMISSIONS.resourceCalendarReadAll])) return null
  return (
    <NavLink
      to='/my-tasks'
      title='My Tasks'
      aria-label='My Tasks'
      className={({ isActive }) =>
        cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
          isActive && 'bg-muted text-primary',
        )
      }
    >
      <ListTodo className='h-4 w-4' />
    </NavLink>
  )
}
